'use strict';

angular.module('cgmemApp')
  .controller('PasswordResetRequestCtrl', function (User) {
    this.status = "";
    this.username = "";

    this.submit = function() {
      this.status = "";
      User.resetRequest(this.username)
      .then(r => {
        this.status = "accepted";
      })
      .catch (err => {
        this.status = (err.status === 404 ? 'rejected' : 'failed');
      });
    }
  });
